import { faCalendarPlus } from "@fortawesome/free-solid-svg-icons";
import DashboardPage from "../../shared/components/DashboardPage"
import Table from "../../shared/components/Table";
import EventItem from "./components/EventItem";
import SideContainer from "../../shared/components/SideContainer";
import EventForm from "./components/EventForm";
import { useEffect, useState } from "react";
import { createEventItem, fetchEventList } from "../../api/Event";
import { formatDate } from "../../util/date";
import { fetchSubmissionByRef } from "../../api/Submission";
import { useNavigate } from "react-router-dom";

const getStartDate = ({ schedules = "[]" }) => {
  const parsedSchedules = JSON.parse(schedules);

  const startSchedule = parsedSchedules[0];

  return startSchedule ? formatDate(startSchedule.date) : ""
}

const getEndDate = ({ schedules = "[]" }) => {
  const parsedSchedules = JSON.parse(schedules);

  const endSchedule = parsedSchedules.at(-1);

  return endSchedule ? formatDate(endSchedule.date) : ""
}

const EventsPage = () => {
  const navigate = useNavigate();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const refLink = urlParams.get('submissionId');
  const [activeCreateForm, setActiveCreateForm] = useState(false);
  const [eventsList, setEventsList] = useState([]);
  const [newEvent, setNewEvent] = useState({});
  const [selectedEvent, setSelectedEvent] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [preFetchedData, setPreFetchData] = useState(null);

  const retrieveList = async () => {
    const res = await fetchEventList();

    if (res.length) {
      setEventsList(res);
      
      if (refLink) {
        const refData = await fetchSubmissionByRef(refLink);

        setPreFetchData(refData);
      }
    }
  };

  useEffect(() => {
    if (preFetchedData) {
      const preFetchedEvent = eventsList.find(evtItem => evtItem.id === preFetchedData.id_event);
      setSelectedEvent(preFetchedEvent)
    }
  }, [preFetchedData]);

  useEffect(() => {
    const userData = localStorage.getItem("user-data");

    if (userData) {
      const parsedData = JSON.parse(userData);

      if (parsedData?.authenticated) {
        retrieveList();

        return;
      }
    }

    navigate("/ems/login");
  }, []);
  const list = [
    {
      isHeader: true,
      details: [
        {
          content: "Event",
        },
        {
          content: "Price",
        },
        {
          content: "Venue",
        },
        {
          content: "Status",
        },
        {
          content: "Start",
        },
        {
          content: "End",
        },
      ]
    },
    ...eventsList.map(listItem => ({
      id: listItem.id,
      details: [
        {
          content: listItem.name,
          customStyle: {
            minWidth: "250px"
          }
        },
        {
          content: new Intl.NumberFormat("en-US", { style: 'currency', currency: 'PHP' }).format(listItem.price),
          customStyle: {
            fontFamily: "Source Code Pro",
            whiteSpace: "nowrap"
          }
        },
        {
          content: listItem.venue,
          customStyle: {
            minWidth: "250px"
          }
        },
        {
          content: listItem.status,
          customStyle: {
            whiteSpace: "nowrap"
          }
        },
        {
          content: getStartDate(listItem),
          customStyle: {
            whiteSpace: "nowrap"
          }
        },
        {
          content: getEndDate(listItem),
          customStyle: {
            whiteSpace: "nowrap"
          }
        },
      ],
    }))
  ].filter(item => {
    if (item.isHeader) return true;

    return item.details[0].content.includes(searchQuery);
  });

  const handleEventCreate = () => {
    setActiveCreateForm(!activeCreateForm);
  };

  const changeNewEvent = (name, value) => {
    console.log("Changing Event Data", name, value);
    setNewEvent({
      ...newEvent,
      [name]: value,
    });
  };

  const submitNewEvent = async (event) => {
    event.preventDefault();

    const res = await createEventItem(newEvent) || {};

    if (res.data?.id) {
      setEventsList([
        ...eventsList,
        {
          ...newEvent,
          id: res.data.id,
          magic_link: res.data.magic_link,
          status: res.data.status,
        },
      ]);
      setNewEvent({});
      handleEventCreate();
      setSelectedEvent({
        ...newEvent,
        id: res.data.id,
        magic_link: res.data.magic_link,
        status: res.data.status,
      });
    }
  }

  const handleSelectedItem = (id) => {
    const eventItem = eventsList.find(evtItem => evtItem.id === id);

    setSelectedEvent(eventItem);
  };

  const handleSearchEvent = (query) => {
    setSearchQuery(query);
  };

  return (
    <DashboardPage title="Event" createIcon={faCalendarPlus} onCreate={handleEventCreate}>
      {!selectedEvent?.id && (
        <Table
          noOfResults={list.length - 1}
          list={list}
          onSelect={handleSelectedItem}
          placeholder="Search events by name..."
          onSearch={handleSearchEvent}
        />
      )}
      
      {!!selectedEvent?.id && (
        <EventItem
          item={selectedEvent}
          updateList={setEventsList}
          setSelectedEvent={setSelectedEvent}
          preFetchedData={preFetchedData}
        />
      )}

      {activeCreateForm && (
        <SideContainer title="Create new Event" onClose={handleEventCreate}>
          <EventForm onChange={changeNewEvent} defaultValues={newEvent} onSubmit={submitNewEvent} />
        </SideContainer>
      )}
    </DashboardPage>
  )
};

export default EventsPage;